import { useState, useEffect, useCallback } from "react";
import { TailSpin } from "react-loader-spinner";
import Dropzone from "react-dropzone";
import { UploadCloud } from "lucide-react";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import {
  Download,
  Plus,
  Search,
  SlidersHorizontal,
  X,
  Rows4,
  GridIcon,
} from "lucide-react";
import _ from "lodash";
import { headingData, loginSuccess } from "../../../slices/auth/login/reducer";
import { createSelector } from "reselect";
import Papa from "papaparse";
import Select from "react-select";
import { PaginationState } from "@tanstack/react-table";
import { useSelector, useDispatch } from "react-redux";
import callApi from "Common/utils/apiCaller";
import { getImageUrl } from "Common/utils/ImageDomain";
import { iconUploader } from "Common/utils/imageUploader";
import { showNotification } from "Common/utils/Notification";
import PaginationContainer from "../../../pages/media/PaginationContainer";

const IconView = ({ showImage, setEventData, togleImage }) => {
  const [mediaType, setMediaType] = useState<any>();
  const [render, setRender] = useState(false);
  const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState<any>("");
  const [mediaData, setMediaData] = useState<any>();
  const [selectedFile, setSelectedFile] = useState<any>("");
  const [fileContent, setFileContent] = useState("");
  const [imageLink, setImageLink] = useState<any>();

  const [pageCount, setPageCount] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 30,
  });
  const [medias, setMedias] = useState("");
  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      user: profile.user,
      error: profile.error,
      success: profile.success,
    })
  );

  const { error, success, user } = useSelector(selectProperties);

  //fetch media
  const debouncedHandler = useCallback(
    _.debounce(
      (
        mediaType: any,

        search: any,
        pagination: any,
        render: any
      ) => {
        return fetchDateWithFilters(
          mediaType,

          search,
          pagination,
          render
        );
      },
      700
    ),
    []
  );
  async function fetchDateWithFilters(
    mediaType: any,

    search: any,
    pagination: any,
    render: any
  ) {
    let filters: { [index: string]: any } = {};
    if (mediaType) {
      filters.media_type = mediaType;
    }

    if (search) {
      filters.qtext = search;
    }
    const localData = await callApi("v1/icon/list", "post", {
      pageNum: pagination?.pageIndex + 1,
      pageSize: pagination?.pageSize,
      filters,
    });

    if (localData?.status === "Success") {
      setMediaData(localData?.data?.iconList);
      setPageCount(
        Math.ceil(localData?.data?.iconCount / pagination?.pageSize)
      );
      setTotalItems(localData?.data?.iconCount);
    }
  }

  useEffect(() => {
    debouncedHandler(mediaType, search, pagination, render);
  }, [mediaType, search, pagination, render]);

  const filterSearchData = (e: any) => {
    const search = e.target.value;
    setSearch(search);
  };
  const options = [
    { value: "Select...", label: "Select Media Type" },
    { value: "video", label: "Video" },
    { value: "image", label: "Image" },
    { value: "audio", label: "Audio" },
    { value: "document", label: "Document" },
  ];
  // const handleChange = (selectedOption: any) => {
  //   if (selectedOption.value === "Select...") {
  //     setMediaType("");
  //   } else {
  //     setMediaType(selectedOption.value);
  //   }
  // };

  const handleAcceptedFiles = async (file: any) => {
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    });
    setSelectedFile(file);
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: function (results: any) {
        setFileContent(results.data);
      },
    });
  };
  const formatBytes = (bytes: any, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };
  useEffect(() => {
    async function fetchMedia(selectedFile: any, id: any) {
      setLoader(true);
      const res = await iconUploader(selectedFile, id);
      setLoader(false);
      if (res.status === "Success") {
        setRender(!render);
        showNotification("Media Uploaded", "success");
      }
    }

    if (selectedFile && selectedFile?.type !== "" && user && user !== "") {
      fetchMedia(selectedFile, user);
    }
  }, [selectedFile, user]);
  return (
    <>
      <ToastContainer closeButton={false} limit={1} />
      <div>
        {/* <h6 className="mb-4 text-15">Search Media</h6> */}
        <div className="flex justify-between">
          <div className="relative my-5 w-[400px]">
            <input
              type="text"
              className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
              placeholder="Search for media"
              autoComplete="off"
              onChange={(e) => filterSearchData(e)}
            />
            <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
          </div>

          <div className="flex justify-end gap-2 my-5">
            <button
              onClick={() => {
                setEventData(imageLink);
                togleImage(!showImage);
                setImageLink(undefined);
              }}
              id="addNew2"
              className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
            >
              Add Media
            </button>
          </div>
        </div>

        {!selectedFile &&
          (loader ? (
            <div className="flex justify-center">
              <TailSpin visible={true} height="50" width="50" color="#4fa94d" />
            </div>
          ) : (
            <div className="flex items-center justify-center bg-white border border-dashed rounded-md cursor-pointer dropzone border-slate-300 dropzone2 dark:bg-zink-700 dark:border-zink-500">
              <Dropzone
                multiple={false}
                onDrop={(acceptedFiles) => {
                  handleAcceptedFiles(acceptedFiles[0]);
                }}
              >
                {({ getRootProps, getInputProps }: any) => (
                  <div
                    className="w-full text-lg text-center dz-message needsclick"
                    {...getRootProps()}
                  >
                    <input {...getInputProps()} />
                    <div className="mb-3">
                      <UploadCloud className="block mx-auto size-12 text-slate-500 fill-slate-200 dark:text-zink-200 dark:fill-zink-500"></UploadCloud>
                    </div>

                    <h5 className="mb-0 font-normal text-slate-500 text-15">
                      Add Files
                    </h5>
                  </div>
                )}
              </Dropzone>
            </div>
          ))}
        {selectedFile &&
          (loader ? (
            <div className="flex justify-center" style={{ marginTop: "10px" }}>
              <TailSpin visible={true} height="50" width="50" color="#4fa94d" />
            </div>
          ) : (
            <ul className="mb-4" id="dropzone-preview">
              <li className="mt-2" id="dropzone-preview-list">
                <div className="border rounded border-slate-200 dark:border-zink-500">
                  <div className="flex justify-between p-2">
                    <div className="flex shrink-0 me-3">
                      <div className="w-[100px] h-[100px] p-2 rounded-md bg-slate-100 dark:bg-zink-600">
                        {selectedFile?.type?.split("/")[0] === "video" ? (
                          <iframe
                            src={selectedFile?.preview}
                            className="block w-full h-full rounded-md"
                          />
                        ) : (
                          <img
                            data-dz-thumbnail
                            className="block w-full h-full rounded-md"
                            src={selectedFile?.preview}
                            alt={selectedFile?.name}
                          />
                        )}
                      </div>

                      <div className="grow">
                        <div className="pt-1 pl-2">
                          <h5 className="mb-1 text-15" data-dz-name>
                            {selectedFile?.name}
                          </h5>
                          <p
                            className="mb-0 text-slate-500 dark:text-zink-200"
                            data-dz-size
                          >
                            {selectedFile?.formattedSize}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="shrink-0 ms-3">
                      <button
                        data-dz-remove
                        type="button"
                        className="px-2 py-1.5 text-xs text-white bg-red-500 border-red-500 btn hover:text-white hover:bg-red-600 hover:border-red-600 focus:text-white focus:bg-red-600 focus:border-red-600 focus:ring focus:ring-red-100 active:text-white active:bg-red-600 active:border-red-600 active:ring active:ring-red-100 dark:ring-custom-400/20"
                        onClick={() => {
                          setSelectedFile(undefined);
                        }}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          ))}
        <div
          className="h-[42vh] overflow-y-auto overflow-hidden mt-3"
          style={{
            scrollbarWidth: "none",
          }}
        >
          <div className="grid grid-cols-4 gap-4 mt-2 mb-2 auto-rows-max">
            {mediaData?.map((item) => (
              <div key={item._id}>
                <div
                  className="relative flex items-center justify-center w-40 h-40 p-2 border border-gray-400 rounded-md cursor-pointer"
                  onClick={() => setImageLink(item)}
                >
                  {item.media_type === "image" ? (
                    <img
                      src={getImageUrl(item.media_url)}
                      alt={item.file_name || "image"}
                      className="object-cover w-full h-full rounded"
                    />
                  ) : item.media_type === "video" ? (
                    <iframe
                      src={getImageUrl(item.media_url)}
                      title={item.file_name || "video"}
                      className="object-cover w-full h-full rounded-md"
                    />
                  ) : null}

                  <input
                    type="checkbox"
                    checked={item._id === imageLink?._id}
                    onChange={() => setImageLink(item)}
                    className="absolute w-4 h-4 pointer-events-none top-1 left-1"
                  />
                </div>
                <div className="w-40 break-words">
                  {item.file_name && (
                    <div className="my-2 text-sm text-red-500 ">
                      {item.file_name}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <PaginationContainer
        setPagination={setPagination}
        isPagination={true}
        columns={[]}
        data={mediaData || []}
        pageCount={pageCount}
        pagination={pagination}
        totalItems={totalItems}
        onPaginationChange={(updater: any) => {
          const nextState = updater(pagination);
          if (nextState?.pageIndex !== pagination?.pageIndex)
            setPagination(nextState);
        }}
        divclassName="overflow-x-auto"
        PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
      />
    </>
  );
};

export default IconView;
